var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderColorFill0Wght400Grad0Opsz48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 48v-6.05h40V48Zm4.1-11.35V30l18.65-18.65L33.4 18 14.75 36.65Zm3-3h2.25L29.1 17.9l-2.25-2.25L11.1 31.4ZM35.6 15.8l-6.65-6.65 4.2-4.2q.55-.65 1.25-.675.7-.025 1.4.675l3.9 3.9q.65.65.65 1.375T39.8 11.6ZM11.1 33.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderColorFill0Wght400Grad0Opsz48);
export default __webpack_public_path__ + "static/media/border_color_FILL0_wght400_GRAD0_opsz48.c8c3410f6fb562471c2464704bb506aa.svg";
export { ForwardRef as ReactComponent };